export default "__VITE_ASSET__BVW$2OFz__"